import React from "react";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { MessageGuestButton } from "@/components/pages/chats/component/MessageGuestButton";
import { Request } from "@/types/request";
import { MessageStaffButton } from "@/components/pages/staff/components/table-cells/MessageStaffButton";
import { MarkOfflinePaymentButton } from "@/components/pages/requests/components/MarkOfflinePaymentButton";

export const RequestActionsCell = ({
  bookingId,
  assignedToStaffIds,
  row,
  onEditRequest,
  showChatAction = false,
  isChatWithGuest = true,
  actionsEditIcon = <Edit className="h-4 w-4" />,
}: {
  bookingId?: string;
  assignedToStaffIds?: string[];
  row: Request;
  onEditRequest?: (
    request: Request,
    e: React.MouseEvent<HTMLButtonElement>,
  ) => void;
  showChatAction?: boolean;
  isChatWithGuest?: boolean;
  actionsEditIcon?: React.ReactNode;
}) => {
  const showMessageGuestButton = showChatAction && bookingId && isChatWithGuest;
  const showMessageStaffButton =
    showChatAction &&
    assignedToStaffIds &&
    assignedToStaffIds.length > 0 &&
    !isChatWithGuest;

  return (
    <div className="flex items-center justify-center gap-1">
      {showMessageGuestButton && (
        <MessageGuestButton bookingId={bookingId} className="p-0" />
      )}
      {showMessageStaffButton && (
        <MessageStaffButton
          userId={assignedToStaffIds}
          className="w-4 h-4 text-indigo/50 hover:text-indigo/50 p-0"
        />
      )}

      <MarkOfflinePaymentButton request={row} compact />

      <Button
        variant="new_ghost"
        size="sm"
        className="h-8 w-8 p-0"
        onClick={(e) => {
          onEditRequest?.(row, e);
        }}
      >
        {actionsEditIcon}
      </Button>
    </div>
  );
};
